export const REDIRECT_URL = "/auth/callback";
export const PROD_AUTH_BASE_URL = "https://auth.somnofy.com/";

export const AUTH_TOKEN_API = "oauth2/token";
export const AUTHORIZE_API = "oauth2/authorize";
export const LOG_OFF_API = "oauth2/logout";
export const TWO_FACTOR_AUTH = "account/two-factor";
